export default __webpack_public_path__ + "5ecaae81fae020545217456d6be4269f.png";